import Button from '__core/modules/atoms/Button/Button';
import InputText from '__core/modules/atoms/InputText/InputText';
import SelectCustomizable from '__core/modules/atoms/SelectCustomizable/SelectCustomizable';
import Image from 'app/components/Image/Image';
import { imageConfig } from 'app/components/Image/imageConfig';
import React, { useState } from 'react';

function UIImage() {
  const [imageUrl, setImageUrl] = useState('https://files.tangerine-dev1.oneclicklabs.es/10243bb0-b4ac-11f0-97d6-8d986021dbf4/edu.png');
  const [displayedUrl, setDisplayedUrl] = useState('');
  const [sizeMax, setSizeMax] = useState(0);

  const handleShowImage = () => {
    setDisplayedUrl(imageUrl);
  };

  const sizeOptions = [
    { label: 'Todos los tamaños disponibles', value: 0 },
    ...imageConfig['extra-images'].map((size) => ({
      label: `Hasta ${size}px`,
      value: size,
    })),
  ];

  return (
    <div>
      <div className="d-flex align-items-end mb-3">
        <div className="w-100 mr-3">
          <InputText label="Image URL" onChange={(e) => setImageUrl(e.target.value)} value={imageUrl} />
        </div>
        <div className="w-25">
          <Button onClick={handleShowImage} text="Ver" />
        </div>
      </div>

      <div className="d-flex mb-3">
        <div className="w-50 mr-3">
          <SelectCustomizable
            label="Simular tamaño máximo disponible"
            onChange={(option) => setSizeMax(option ? option.value : 0)}
            options={sizeOptions}
            value={sizeOptions.find((o) => o.value === sizeMax)}
          />
        </div>
      </div>

      {displayedUrl && (
        <div className="mb-3">
          <div
            style={{
              border: '2px dashed #c6cfdc',
              padding: '16px',
              borderRadius: '4px',
              backgroundColor: '#f7f9fc',
              overflow: 'hidden',
            }}
          >
            <Image
              key={`${displayedUrl}-${sizeMax}`}
              showDebug
              sizeMax={sizeMax}
              src={displayedUrl}
              style={{ maxWidth: '100%', height: 'auto', display: 'block' }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default UIImage;
